export default __webpack_public_path__ + "static/stickers_phonesmartjoin-in-74a395d3e413eefa8d87d8b7c0a4732f.png";